import { Grid2 as Grid } from "@mui/material";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { OrganizationWizardStepper } from "./fragments/OrganizationWizardStepper";
import { OrganizationDetailsStep } from "./fragments/OrganizationDetailsStep";
import { OrganizationWashTypesStep } from "./fragments/OrganizationWashTypesStep";
import { OrganizationReviewStep } from "./fragments/OrganizationReviewStep";
import { OrganizationCreateSuccess } from "./fragments/OrganizationCreateSuccess";
import {
  createOrganizationWizardStepAtom,
  isCreateOrganizationModeAtom,
  isCreateOrganizationSuccessAtom,
  organizationWizardProfileAtom,
  organizationWizardWashTypesAtom,
  selectedOrgIdAtom,
} from "../../atoms";
import { SadmOrganizationsRoute } from "../../routes";

export const CreateOrganizationWizard = () => {
  const [step, setStep] = useAtom(createOrganizationWizardStepAtom);
  const [isSuccess, setIsSuccess] = useAtom(isCreateOrganizationSuccessAtom);
  const [, setWizardProfile] = useAtom(organizationWizardProfileAtom);
  const [, setWizardWashTypes] = useAtom(organizationWizardWashTypesAtom);
  const [selectedOrgId] = useAtom(selectedOrgIdAtom);
  const [, setIsCreateOrganizationMode] = useAtom(isCreateOrganizationModeAtom);
  const navigate = useNavigate();

  const resetWizard = () => {
    setStep(0);
    setIsSuccess(false);
    setWizardProfile(undefined);
    setWizardWashTypes([]);
  };

  const handleViewOrganization = () => {
    const orgId = selectedOrgId;
    setIsCreateOrganizationMode(false);
    resetWizard();
    navigate(`${SadmOrganizationsRoute.path}/${orgId}`);
  };

  if (isSuccess) {
    return (
      <OrganizationCreateSuccess onViewOrganization={handleViewOrganization} />
    );
  }

  return (
    <Grid
      container
      direction="column"
      sx={{
        width: "100%",
        maxWidth: "100%",
        backgroundColor: "#fff",
        borderRadius: "10px",
        boxShadow: "0px 0px 4px 0px #00000040",
        minWidth: 0,
        overflow: "visible",
      }}
    >
      <OrganizationWizardStepper activeStep={step} />

      <Grid
        container
        size={12}
        sx={{
          width: "100%",
          px: { xs: 1, sm: 2, md: 3 },
          pb: {
            xs: "max(16px, env(safe-area-inset-bottom))",
            sm: 2,
            md: 3,
          },
        }}
      >
        {step === 0 && <OrganizationDetailsStep />}
        {step === 1 && <OrganizationWashTypesStep />}
        {step === 2 && <OrganizationReviewStep />}
      </Grid>
    </Grid>
  );
};
